import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Short, human-recognisable Program ID tag — e.g. "#CD34EF".
 * Pass any of program_id / program_ref / _id (first truthy wins); returns the
 * last 6 alphanumeric chars, uppercased, prefixed with "#". Empty string if none.
 */
export function programTag(...ids) {
  const raw = ids.find((x) => x != null && String(x).trim() !== "");
  if (!raw) return "";
  const s = String(raw).replace(/[^a-zA-Z0-9]/g, "");
  return s ? "#" + s.slice(-6).toUpperCase() : "";
}
